import { render, staticRenderFns } from "./ModalUpdateProduit.vue?vue&type=template&id=18917bbf&scoped=true&"
import script from "./ModalUpdateProduit.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateProduit.vue?vue&type=script&lang=js&"
import style0 from "./ModalUpdateProduit.vue?vue&type=style&index=0&id=18917bbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18917bbf",
  null
  
)

export default component.exports